import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./EditArticlePage.css";
import { getAnArticleApi, getArticleComponentsApi } from "../../api/articles";
import { loadATitleRequestAction } from "../../redux/actions/appTitles";
import { loadAnIssueRequestAction } from "../../redux/actions/appIssues";
import PdfEditArticleContainer from "../../components/PdfEditArticleContainer/PdfEditArticleContainer";
import WebEditArticleContainer from "../../components/WebEditArticleContainer/WebEditArticleContainer";
import Badge from "react-bootstrap/Badge";

class EditArticlePage extends React.Component {
  constructor(props) {
    super(props);
    this.handleResize = this.handleResize.bind(this);

    this.state = {
      windowWidth: window.innerWidth,
      article: null,
      components: null,
      loadedArticleID: null
    };
  }

  componentDidMount() {
    const { match, history } = this.props;

    window.addEventListener("resize", this.handleResize);

    if (this.props.titleName == null) {
      this.props.loadATitleRequestAction(match.params.titleID, toast, history);
    }

    if (this.props.issueName == null) {
      this.loadIssue();
    }

    this.loadArticle();
  }

  async loadArticle() {
    const { match } = this.props;
    const articleID = match.params.articleID;

    try {
      const [article, components] = await Promise.all([
        getAnArticleApi(articleID),
        getArticleComponentsApi(articleID)
      ]).catch(e => {
        throw e;
      });

      this.setState({
        article: article,
        components: components,
        loadedArticleID: articleID
      });
    } catch (e) {
      toast.error(e.toString());
    }
  }

  componentDidUpdate() {
    const { match } = this.props;
    const articleID = match.params.articleID;

    if (articleID !== this.state.loadedArticleID) {
      this.loadArticle();
    }
  }

  loadIssue() {
    const { match, history, loadAnIssueRequestAction } = this.props;
    loadAnIssueRequestAction(
      match.params.issueID,
      match.params.bookType === "pdf_books",
      toast,
      history
    );
  }

  renderSwitch() {
    const { title, issue, match } = this.props;
    const isPdf = match.params.bookType === "pdf_books";
    const { loadedArticleID, article, components } = this.state;

    const loaded = loadedArticleID === match.params.articleID;

    if (!loaded) {
      return (
        <div className="article_spinner_container">
          <Spinner animation="grow" />
        </div>
      );
    } else if (isPdf) {
      return (
        <PdfEditArticleContainer
          title={title}
          issue={issue}
          article={article}
          components={components}
        />
      );
    } else {
      return (
        <WebEditArticleContainer
          title={title}
          issue={issue}
          article={article}
        />
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.setState({
      windowWidth: window.innerWidth
    });
  }

  render() {
    const { match, issue, title, zoomed } = this.props;

    const meTitleLink = `${process.env.REACT_APP_URL_ROOT}titles/${
      match.params.titleID
    }/pdf_books`;
    const titleName = title != null ? title.name : "";
    const titleAutomate = title != null ? title.automate : 0;

    const meLink = `${process.env.REACT_APP_URL_ROOT}titles/${
      match.params.titleID
    }/${match.params.bookType}/${match.params.issueID}`;
    const issueName = issue != null ? issue.issue : "";

    const small = this.state.windowWidth < 700;

    return (
      <Container
        className="edit_toc_page"
        style={
          zoomed
            ? { maxWidth: "3072px", width: "3072px", paddingRight: "700px" }
            : {
                maxWidth: small ? "calc(100% + 700px)" : "calc(100% + 350px)",
                width: small ? "calc(100% + 700px)" : "calc(100% + 350px)",
                paddingRight: "700px"
              }
        }
      >
        <Row>
          <Col>
            <Breadcrumb active="true" className="path_container">
              <Breadcrumb.Item href={process.env.REACT_APP_URL_ROOT}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item href={meTitleLink}>
                {titleName}
                {titleAutomate >= 1 && (
                  <Badge
                    variant="warning"
                    className="title_list_item_auto_badge"
                  >
                    {titleAutomate >= 2 ? "Fit Reading" : "TOC"}
                  </Badge>
                )}
              </Breadcrumb.Item>
              <Breadcrumb.Item href={meLink}>{issueName}</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <Row>
          <Col>{this.renderSwitch()}</Col>
        </Row>
      </Container>
    );
  }
}

const mapState = (state, ownProps) => {
  const { appTitles, appIssues, pdfEditTocContainer } = state;
  const { match } = ownProps;

  return {
    title: appTitles[match.params.titleID],
    issue: appIssues[match.params.issueID],
    zoomed: pdfEditTocContainer.zoomed
  };
};

const mapDispatch = {
  loadATitleRequestAction,
  loadAnIssueRequestAction
};

export default connect(
  mapState,
  mapDispatch
)(withRouter(EditArticlePage));
